import { NAMESPACE } from "./_Namespace";

export class RadHistory
{
    public static classNamespace = NAMESPACE + "RadHistory";
    public static className = "RadHistory";
    public static get classFullName() { return `${this.classNamespace}.${this.className}`; }

    public static pushStateCounter = 0;
}